/**
 * @copyright 2019 @ DigiNet
 * @author VINHLE
 * @create 2019/09/22 15:37
 * @update 2019/09/22 15:37
 */

import Api from '../../../services/api.js';

export default async (param)=> {
    return new Promise((resolve, reject) => {
        Api.put('/w18f1017/add', param)
            .then(result => {
                return resolve(result);
            });
    } );
};